// extracted by mini-css-extract-plugin
module.exports = {"property":"styles__property--3bNiN","value":"styles__value--b-LsX","sublistItem":"styles__sublistItem--2oNjF","divider":"styles__divider--2hEvU","list":"styles__list--YbGYp"};